import { booleanAttribute, Directive, input } from '@angular/core';

@Directive({
  selector: '[uiMaskPii]',
  host: {
    '[attr.data-clarity-mask]': 'uiMaskPii()', // clarity
    '[class.fvMask]': 'uiMaskPii()', // fullview
  },
})
export class MaskPiiDirective {
  uiMaskPii = input(true, { transform: booleanAttribute });
}
